import React from 'react';
import styled, { css } from 'styled-components';

const IframeWrapper = styled.button`
    border-radius: 25px;
    padding: 0;
    justify-content: center;
    align-items: center;
    border: 1px solid #cdcece;
    overflow: hidden;
    img {
        width: 100%;
        border-radius: 25px;
        height: 100%;
        overflow: scroll;
        transform: 
            scale(var(--translation1))
            rotate(var(--translation2));
    }
    iframe {
        width: 100%;
        border-radius: 25px;
        height: 100%;
        overflow: scroll;
        transform: 
            scale(var(--translation1))
            rotate(var(--translation2));
    }
    ${(props) =>
        props.theme === 'big' &&
        css`
        height: 25em;
        width: 40em;
        `}
    ${(props) =>
        props.theme === 'small' &&
        css`
        height: 15em;
        width: 25em;
        `}
`

// const Photo = ({
//     id,
//     class_name = 'photo',
//     theme = 'approve',
//     image = ''
// }) => {
//     return (
//         <PhotoWrapper
//             className={class_name}
//             id={id}
//             theme={theme}
//             image={image}
//         >
//             <img src={props.image} />
//             {props.children}
//         </PhotoWrapper>
//     );
// };

const Iframe = (props) => {
    // Draggable.create("#map img", {
    //     type:"x,y",
    //         bounds:"#wrapper",
    //         edgeResistance:0.5
    //  });
    // document.getElementById("dummyImage").style.var(--translation1) = props.zoom;
    return (
        // <div id='main-photo'>
        <IframeWrapper id={props.id} class_name={props.className} theme={props.theme} zoom={props.zoom} rotate={props.rotate}>
            <iframe src={props.image} alt='' draggable="true" style={{ "--translation1": props.zoom, "--translation2": props.rotate + "deg" }}/>
            {/* <img src={logo} alt='' draggable="true" style={{ "--translation1": props.zoom, "--translation2": props.rotate + "deg" }} /> */}
        </IframeWrapper>
        // </div>
    )
};

export default Iframe;